import { Component, OnInit } from "@angular/core";
import { CandidateListService } from "../../shared/services/candidate-list/candidate-list.service";
import { Router } from "@angular/router";
import { first } from 'rxjs/operators';
import Swal from "sweetalert2";
@Component({
  selector: "app-candidate-list",
  templateUrl: "./candidate-list.component.html",
  styleUrls: ["./candidate-list.component.scss"]
})
export class CandidateListComponent implements OnInit {
  data: any;

  filter: any = {
    key: ""
  };

  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  candidateCount = 0;
  /** end pagination */

  candidateErrors: any = [];

  constructor(
    private router: Router,
    private candidateListService: CandidateListService
  ) { }

  ngOnInit() {
    this.searchcandidateList();
    this.getCandidateErrors();
  }

  searchcandidateList() {
    this.candidateListService
      .searchCandidates(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.candidateCount = res["count"];
        this.data = res["data"];
      });
  }


  getCandidateErrors() {
    this.candidateListService.candidateError()
      .pipe(first())
      .subscribe(res => {
        this.candidateErrors = res;
      });
  }

  fetchcandidateData(e) {
    this.currentPage = e;
    this.searchcandidateList();
  }

  clearCandidateList() {
    this.filter.key = "";
    this.searchcandidateList();
  }

  OnClick(id) {
    this.router.navigate(["manager/" + "candidate/" + id]);
  }

  deleteAllCandidates() {
    Swal.fire({
      title: "Are you sure?",
      text: "Candidate data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.yesDeleteAll();
      }
    });
  }

  yesDeleteAll() {
    this.candidateListService
      .deleteAll()
      .pipe(first())
      .subscribe(res => {
        this.searchcandidateList();
      });
  }

  downloadTemplate() {
    window.open('assets/candidate.zip');
  }
}
